import React from 'react';

//import { Navbar, Nav, NavItem } from 'reactstrap';

const Footer = () => {
  return <></>;
};

export default Footer;
